import { DownloadOutlined, ExportOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { useState } from "react";
import * as XLSX from "xlsx";
import moment from "moment";
import { formatDate } from "utils/dateFormat";
import { useAppSelector } from "store";
import {  getExportTransportShhiped } from "services/shipping";
import { ExportTransportShippedBoxData } from "services/interface";

const ExportToExcel = () => {
  const [loading, setLoading] = useState(false);
  const usrName = useAppSelector((state) => state.auth.profile?.user?.name);

  const fecthData = async () => {
    try {
      const response = await getExportTransportShhiped();
      if (response.status === "success" && response) {
        return response.data;
      }
    } catch (error) {
      console.log(error);

      return undefined;
    } finally {
      // setLoading(false)
    }
  };

  const exportToExcel = async () => {
    // console.log('exportToExcel')

    setLoading(true);

    try {
      let data = await fecthData();

      //unique by box_id
      const boxUniq = data?.box_list.reduce((acc: any, current: any) => {
        const x = acc.find((item: any) => item.box_id === current.box_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }
      , []);

      // sort box by box_id
      boxUniq.sort((a: any, b: any) => {
        return a.box_id - b.box_id;
      });

      // sort order by order_date
      let arrdata = data?.order_list.sort((a: any, b: any) => {
        return new Date(b.order_date).getTime() - new Date(a.order_date).getTime();
      }
    );
        

      let arr = arrdata?.map((item, index) => {
        //ค้นหา box ด้วย order_id
        let box:ExportTransportShippedBoxData[] = [];

        if(data?.box_list){
          box = data.box_list.filter((box: any) => box.order_id === item.order_id);
        }


        let boxFull:ExportTransportShippedBoxData[] = [];
        // ทำให้ box และ boxUniq มีข้อมูลเท่ากัน โดยเพิ่ม box_qty = 0 ถ้าไม่มีข้อมูล
        boxUniq.forEach((item: any) => {
          const boxData = box.find((box: any) => box.box_id === item.box_id);
          if (boxData) {
            boxFull.push(boxData);
          } else {
            boxFull.push({
              box_id: item.box_id, box_name: item.box_name, box_qty: 0,
              order_id: ""
            });
          }
        });




        const newData = {
          ลำดับ: index + 1,
          "order No.": item.order_code,
          "วันที่จัดส่ง": formatDate(item.transport_date),
          "ชื่อลูกค้า จังหวัด": `${item.contact_name} ${item.province_name} ${item.contact_tel}`,
          "ขนส่งผ่าน": `${item.transport_name}`,
          "จังหวัดปลายทาง": `${item.parking_province}`,
          "อำเภอปลายทาง": `${item.parking_district}`,
          "จุดจอด": `${item.parking_name}`,
          //render box 
          ...boxFull.reduce((acc: any, current: any) => {
            acc[current.box_name] = current.box_qty === 0 ? "" : current.box_qty;
            return acc;
          }, {}),
        };

        return newData;
      });

      //  console.log(arr)

      if (arr) {
        let Heading = [
          [
            "ลำดับ",
            "order No.",
            "วันที่จัดส่ง",
            "ชื่อลูกค้า จังหวัด",
            "ขนส่งผ่าน",
            "จังหวัดปลายทาง",
            "อำเภอปลายทาง",
            "จุดจอด",
            //header ตาม boxUnique
            ...boxUniq.map((item: any) => item.box_name)
          ],
        ];

        const tableName = `Transport Shipping`;
        const exportDate = `Export Date: ${moment(new Date()).format("DD-MM-YYYY")}`;
        const exportName =  `User: ${usrName}`;

        const wb = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

        XLSX.utils.sheet_add_aoa(ws, [[tableName]], { origin: "A1" });
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];
        XLSX.utils.sheet_add_aoa(ws, [[exportName]], { origin: "A2" });
        XLSX.utils.sheet_add_aoa(ws, [[exportDate]], { origin: "A3" });
        XLSX.utils.sheet_add_aoa(ws, Heading,  { origin: "A5" });
        XLSX.utils.sheet_add_json(ws, arr, { origin: "A6", skipHeader: true });

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        XLSX.writeFile(wb, genfileName());
      } else {
        message.error("ไม่สามารถดาวน์โหลดไฟล์ได้");
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log(error);
      message.error("ไม่สามารถดาวน์โหลดไฟล์ได้");
      setLoading(false);
      return;
    }

    setLoading(false);
  };

  const genfileName = () => {
    const date = new Date();
    const fileName = `transport_shipping${moment(date).format(
      "DD-MM-YYYY-HHMMSS"
    )}.xlsx`;
    return fileName;
  };

  return (
    <Button
      type="default"
      style={{ marginRight: 10 }}
      icon={<DownloadOutlined />}
      size="middle"
      loading={loading}
      onClick={exportToExcel}
    >
      ส่งออก Excel
    </Button>
  );
};

export default ExportToExcel;
